import { useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/pro-regular-svg-icons';
import { ScreenPreview } from "./";
import { EditableAdvancedLoopScreen, EditableTableScreen } from "./";
import { addNewLoopEntry } from "../../store/actions/client";
import { loopClientEntriesSelector, clientEntriesSelector } from "../../store/selectors/clientEntries";
import { addNewLoopEntrySelector, interactiveClientSelector, allowLoopEditsSelector } from "../../store/selectors/clientSettings";
import { conditionsSelector } from "../../store/selectors/entities/conditions";
import { conditionCheck } from "../../lib/conditions";
import { prepareScreen, getSubSheetScreens } from "../../lib/sheets";
import { guid, getStaticLoopValue, createNewRow } from "../../lib/utils";
import { applyValidations } from "../../lib/fields";
const LoopTableViewPreview = ({
  keyField,
  entries,
  sheet
}) => {
  const previewEntries = useSelector(clientEntriesSelector);
  const conditions = useSelector(conditionsSelector);
  const dispatch = useDispatch();
  const isUserAddingNewLoopEntry = useSelector(addNewLoopEntrySelector);
  const allEntries = [keyField, ...entries];

  // TODO: optimize for loops
  // this loops over the entries twice, but no choice unless we refactor
  // the full adjustedPreviewEntries is necessary in order to run conditionCheck
  // would be better to do this outside this component
  const adjustedPreviewEntries = previewEntries.map(entry => {
    const {
      rowGuid,
      parentGuid
    } = entry;
    if (rowGuid === isUserAddingNewLoopEntry) {
      return {
        ...entry,
        guid: parentGuid
      };
    }
    return entry;
  });
  const tablePreviewValues = previewEntries.reduce((acc, entry) => {
    const {
      rowGuid,
      parentGuid
    } = entry;
    if (rowGuid === isUserAddingNewLoopEntry) {
      acc.push({
        conditionMet: conditionCheck(parentGuid, adjustedPreviewEntries, conditions, rowGuid),
        ...applyValidations(entry)
      });
    }
    return acc;
  }, []);
  return <>
      {isUserAddingNewLoopEntry ? <ScreenPreview entries={tablePreviewValues} /> : <TableViewPreview entries={allEntries} addNewLoopEntry={() => {
      const newLoopRow = createNewRow(allEntries);
      dispatch(addNewLoopEntry(newLoopRow));
    }} sheet={sheet} />}
    </>;
};
const TableViewPreview = ({
  entries,
  addNewLoopEntry,
  sheet
}) => {
  const loopValues = useSelector(loopClientEntriesSelector);
  const interactiveClient = useSelector(interactiveClientSelector) || false;
  const activeCol = useRef(null);
  let allEntries = entries.length > 4 ? entries : [...entries, ...Array(4 - entries.length).fill({
    empty: 'empty',
    label: '',
    default: '',
    guid: guid()
  })];

  // Grab all the rowIds by sheet
  const rowGuids = [...new Set(loopValues.filter(({
    sheet_id
  }) => sheet_id === sheet.id).map(({
    rowGuid
  }) => rowGuid))];

  // Add any additional rows to fill out the table
  const prepareRows = rows => {
    const rowsMinimum = 5;
    if (rows.length < rowsMinimum) {
      const rowsNeeded = Array(rowsMinimum - rows.length).fill({
        value: ''
      });
      return rows.concat(rowsNeeded);
    }
    return rows;
  };
  const smartPreviewItemLoopLookup = guid => {
    const rows = prepareRows(rowGuids);
    return rows.map((rowGuid, i) => {
      // Find all values for a given row.
      const {
        type,
        value
      } = loopValues.find(loopItem => {
        if (loopItem.parentGuid == guid && loopItem.rowGuid === rowGuid) {
          return loopItem;
        }
      }) || {
        value: '',
        type: ''
      };
      const columnValue = getStaticLoopValue(type, value);
      return <div className="cell" key={`col-${i}`}>
          <div className="loop--value userAdded">{columnValue}</div>
        </div>;
    });
  };
  return <div className="tableview--preview">
      <div className="table-view--wrapper">
        <div className="table">
          {allEntries.map(({
          guid,
          label,
          default: defaultValue,
          empty = ''
        }, i) => {
          const active = false;
          const style = {};
          const first = i === 0;
          return <div className={`col ${empty} ${active ? 'col--active' : ''}`} key={`${label}-key-${i}`} ref={active || first ? activeCol : null} style={style}>
                  <div className="field--name">{label}</div>
                  <div className="cell default--values">
                    <div className="loop--value">{defaultValue}</div>
                  </div>
                  {smartPreviewItemLoopLookup(guid)}
                </div>;
        })}
        </div>
      </div>
      {!interactiveClient && <div className="notification">
          <div className="notification--icon">
            <i className="foundry-icon icon--info icon--gray" />
          </div>
          <div className="notification--msg">
            Users can add as many rows as they want.
          </div>
        </div>}

      <button className="foundry--button button--active btn--sm add-item" onClick={addNewLoopEntry}>
        <FontAwesomeIcon className="preview--loop--addItem" icon={faPlus} />
        <span className="button--label">Add Item</span>
      </button>
    </div>;
};
export const LoopScreenPreview = ({
  sheet,
  ignoreConditions
}) => {
  const allowLoopEdits = useSelector(allowLoopEditsSelector);
  const loopEntries = prepareScreen(sheet);
  const screenDescription = loopEntries.screens[0].sheet.description;
  const keyField = loopEntries.keyField;
  const entries = loopEntries.screens[0].entries;
  const subSheetScreens = getSubSheetScreens(sheet);
  const editableLoopScreenComponents = {
    13: EditableAdvancedLoopScreen,
    15: EditableTableScreen
  };
  const TableComponent = allowLoopEdits ? editableLoopScreenComponents[`${sheet.sheet_type_id}`] : LoopTableViewPreview;
  return <TableComponent ignoreConditions={ignoreConditions} screenName={screenDescription} keyField={keyField} entries={entries} sheet={sheet} subSheetScreens={subSheetScreens} />;
};